export class Csp5020Class {
    UserNam: string;
}
